import VendorBusinessTypeSelect from "@/components/form/vendor-business-type-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";
import type { VendorType } from "@/types/openapi-enum";

/** **Value is a `VendorType`** — the vendor's line of business. */
export type VendorBusinessTypeFieldProps = PickerFieldProps<VendorType | null>;

export const VendorBusinessTypeField = makePickerField<VendorType | null>({
  name: "VendorBusinessTypeField",
  control: VendorBusinessTypeSelect,
  popout: true,
});
